import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { FilterOption } from 'models/Filters';
import { LISTING_STAGE } from 'models/Listing';
import { LISTING_STATUS_LABEL } from 'data/dealStatus';

export const HAS_LISTING_FILTER_KEY = 'hasListing';
export const LISTING_STATUS_FILTER_KEY = 'listingStatus';

const useActivityMetricsFilterOptions = () => {
  const { t } = useTranslation();

  return useMemo(
    () =>
      [
        {
          value: HAS_LISTING_FILTER_KEY,
          label: t('listingAdded'),
          options: [
            { value: 'true', label: t('yes') },
            { value: 'false', label: t('no') },
          ],
        },
        {
          value: LISTING_STATUS_FILTER_KEY,
          label: t('listingStatus'),
          options: Object.values(LISTING_STAGE).map((value) => ({
            value,
            label: t(LISTING_STATUS_LABEL[value]),
          })),
        },
      ] as FilterOption[],
    [t],
  );
};

export default useActivityMetricsFilterOptions;
